//this is happening here, so history can be manipulated without being used in a component
import {createBrowserHistory} from 'history';
export default createBrowserHistory();